import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box,
} from '@mui/material';

const TransferConfirmationModal = ({ open, onClose, playerToAcquire, replaceablePlayers, onConfirm, isTeamComplete }) => {
    const [selectedPlayer, setSelectedPlayer] = useState('');

    const handleConfirm = () => {
        onConfirm(selectedPlayer || null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Speler {isTeamComplete ? 'Vervangen' : 'Aantrekken'}</DialogTitle>
            <DialogContent>
                <Typography gutterBottom>
                    Je staat op het punt om <strong>{playerToAcquire?.name}</strong> aan te trekken.
                </Typography>
                {isTeamComplete ? (
                    <>
                        <Typography gutterBottom>
                            Selecteer een speler uit je team om te vervangen:
                        </Typography>
                        <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                            <InputLabel>Te vervangen speler</InputLabel>
                            <Select
                                value={selectedPlayer}
                                onChange={(e) => setSelectedPlayer(e.target.value)}
                                label="Te vervangen speler"
                            >
                                <MenuItem value=""><em>Selecteer een speler</em></MenuItem>
                                {replaceablePlayers.map((player) => (
                                    <MenuItem key={player.id} value={player.id}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Typography variant="body1">{player.name}</Typography>
                                            <Typography variant="caption" color="text.secondary">({player.position})</Typography>
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                ) : (
                    <Typography gutterBottom sx={{ mt: 2 }}>
                        Weet je zeker dat je <strong>{playerToAcquire?.name}</strong> wilt aantrekken om je selectie weer compleet te maken?
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button 
                    onClick={handleConfirm} 
                    color="primary" 
                    variant="contained" 
                    disabled={isTeamComplete && !selectedPlayer}
                >
                    Here we go!
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TransferConfirmationModal;
